import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface LibraryCounts {
  drafts: number;
  recent: number;
  favorites: number;
}

export function useLibraryCounts(userId: string | undefined) {
  return useQuery({
    queryKey: ["library-counts", userId],
    queryFn: async (): Promise<LibraryCounts> => {
      if (!userId) return { drafts: 0, recent: 0, favorites: 0 };

      // Fetch all counts in parallel
      const [draftsResult, favoritesResult, recentResult] = await Promise.all([
        supabase.rpc("get_user_drafts", { _user_id: userId }),
        supabase.rpc("get_user_favorites", { _user_id: userId }),
        supabase.rpc("get_user_scored_submission_count", { _user_id: userId }),
      ]);

      return {
        drafts: draftsResult.data?.filter((draft) => draft.status !== "abandoned").length || 0,
        recent: recentResult.data || 0,
        favorites: favoritesResult.data?.length || 0,
      };
    },
    enabled: !!userId,
    staleTime: 30000, // 30 seconds
  });
}
